/* eslint-disable  react/display-name*/
import {
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
  Grid,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";

import PSnakbar from "../../../../components/pos/PSnakbar";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../../utils/API";
import UserCrud from "./DeviceCrud.jsx";

export default function DeviceList(props) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const translate = t;
  const [searchStr, setSearchStr] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  function addUser() {
    biRef.child.showDeviceCrudWindow(null);
  }

  function onEditClicked(row) {
    biRef.child.showDeviceCrudWindow(row.tableData[row.rowIndex].id);
  }

  async function loadData() {
    loadByRest(0, 100, "[]", "[]");
    //loaadByDB();
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    setIsLoading(true);
    const result = await API.get(
      "/auth/v1/devices/list?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );

    var arr = result.headers["content-range"].split("/");

    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data);
    setIsLoading(false);
  }

  async function onTableChange(tableState) {
    console.log(tableState.sortOrder);
    let sort = "[]";
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    let search = "[]";
    if (tableState.searchText) {
      let str = "[";
      str = str + '{id:"name",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"code",value:"' + tableState.searchText + '"}';

      str = str + "]";
      search = str;
    }
    loadByRest(tableState.page, tableState.rowsPerPage, sort, search);
  }

  const options = {
    serverSide: true,
    filterType: "dropdown",
    download: false,
    search: false,
    filter: false,
    pagination: false,
    viewColumns: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,

    print: false,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={translate("Refresh Data")}>
            <IconButton size="small" color="primary" onClick={userListRefresh}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={translate("Add User")}>
            <IconButton size="small" color="secondary" onClick={addUser}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  const [option, setOption] = useState(options);

  const columns = [
    {
      name: "name",
      label: translate("Name"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({ align: "right" }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <Button
            onClick={() => onEditClicked(tableMeta, updateValue, value)}
            color="secondary"
            style={{
              margin: 0,
              padding: 0,
              height: 17,
              width: 27,
              alignText: "right",
            }}
          >
            Edit
          </Button>
        ),
      },
    },
  ];

  function userListRefresh() {
    loadData();
  }

  var biRef = {};

  return (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={
              <Typography variant="h6">
                {translate("Device List")}
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{ marginLeft: 15, position: "relative", top: 4 }}
                  />
                )}
              </Typography>
            }
            data={data}
            columns={columns}
            options={option}
          />
        </div>
      </Grid>
      <UserCrud
        biRef={biRef}
        showMessage={props.showMessage}
        onRefresh={userListRefresh}
      ></UserCrud>
    </Grid>
  );
}
